<ng-container>
  <automata-automation-replacement-chips
    label="AUTOMATIONS.EDITOR.FILTERS.ACCOUNT_GROUP_DATA.DATA_LABELS.SALES_TEAM"
    [dataService]="salesTeamSelectorService"
    [formControl]="salesTeamOptionControl"
    [isRequired]="true"
    [multiple]="true"
    [supportDataPassing]="false"
  ></automata-automation-replacement-chips>
</ng-container>
